import React, { useCallback, useMemo, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { clsx } from 'clsx'
import { useQuestionState } from './allFields'
import {
  getCompletedFields,
  selectSectionAndQuestionByKey,
  jumpToQuestion as jumpToQuestionAction,
} from '../../../slices/formInstanceSlice'
import { Collapse } from 'components/QuestionnaireRequestAutomated/processor/components/RequestInfo'
import { LabelName } from 'components/utility/sandbox_upload/FileUploader/FileItemStatus'
import { useGetColumns } from 'components/utility/sandbox_upload/hooks'
import { toKb } from 'components/utility/sandbox_upload/FileUploader/utils'
import { TAB } from 'components/QuestionnaireRequestAutomated/processor/components/ProcessInterstitial/Fields/Main'

const Label = ({ fileName, id, onSearch }) => {
  const wrapperRef = useRef()

  return (
    <div
      className="file-item-label-container-wrapper dome-relative dome-d-flex dome-gap12 dome-align-center"
      ref={wrapperRef}
    >
      <LabelName text={fileName} wrapperRef={wrapperRef} />
      {onSearch && (
        <span onClick={onSearch} className="dome-cursor-pointer">
          <i className="fa-light fa-magnifying-glass"></i>
        </span>
      )}
    </div>
  )
}

function FileItemSuccess({ fileName, id, fileSize, fileUrl, externalAction = null }) {
  const onSearch = useCallback(() => {
    if (!fileUrl) return

    window.open(fileUrl, '_blank')
  }, [fileUrl])

  return (
    <div className="file-item dome-d-flex dome-flex-column">
      <Label fileName={fileName} id={id} onSearch={onSearch} />
      <div className="dome-d-flex file-item-success dome-justify-between">
        <div className="dome-d-flex dome-gap6 dome-align-center">
          <span>
            <i className="dome-color-sage fa-sharp fa-regular fa-circle-check"></i>
          </span>
          <span className="dome-color-dark-grey">{toKb(fileSize)}</span>
        </div>
        {externalAction}
      </div>
    </div>
  )
}

const ViewQuestion = ({ field, classes = [] }) => {
  const dispatch = useDispatch()
  const [sectionIndex, nodeIndex] = useSelector((state) => selectSectionAndQuestionByKey(state, field.id))
  const jumpToQuestion = useCallback(() => {
    if (!sectionIndex || !nodeIndex) return

    dispatch(jumpToQuestionAction({ sectionIndex, nodeIndex, fieldId: field.id, tab: TAB.ALL }))
  }, [dispatch, sectionIndex, nodeIndex])

  return (
    <button
      className={clsx(classes, 'dome-btn dome-btn-link dome-btn-link-aqua dome-btn-link-chevron-right')}
      style={{ fontSize: '10px', fontStyle: 'italic' }}
      onClick={() => jumpToQuestion()}
    >
      view question
    </button>
  )
}

const ReadonlyFileField = ({ field }) => {
  const { value } = useQuestionState(field.id)

  if (!value) return null

  return (
    <FileItemSuccess
      fileName={value.file.name}
      id={field.id}
      fileSize={value.file.size}
      fileUrl={value.metadata?.urls?.pdf || value.metadata?.urls?.original}
      externalAction={<ViewQuestion field={field} />}
    />
  )
}

export default function PreviousAnsweredFileFields() {
  const completedFields = useSelector(getCompletedFields)
  const fileFields = useMemo(
    () => Object.values(completedFields).filter((field) => field.type === 'file'),
    [completedFields]
  )
  const [column, ref] = useGetColumns(500, fileFields.length === 1)

  if (fileFields.length === 0) return null

  return (
    <div style={{ padding: '24px 32px', borderRadius: 6, background: 'white' }}>
      <div ref={ref}>
        <Collapse title="previously attached files" titleClassName="dome-p2 dome-color-dark-grey">
          <div style={{ marginTop: 18 }} className="dome-file-uploader">
            <div aria-colspan={column} className="dome-file-uploader-list-item">
              <div className="dome-d-flex dome-gap6 dome-flex-column">
                {fileFields.map((field) => (
                  <ReadonlyFileField key={field.id} field={field} />
                ))}
              </div>
            </div>
          </div>
        </Collapse>
      </div>
    </div>
  )
}
